<template>
  <div>
      <!--<banet-info :show="showAlertInfo" :isHtml="isHtml" :label="infoMessage" :btnClose="true"-->
                  <!--@closeAlertInfo="closeAlert()"></banet-info>-->
      <!--<banet-warning :show="appErrorsActive" :label="warningMessage" :btnClose="true" :selfclose="true"-->
                     <!--@closeAlertWarning="closeAlertWarning()"></banet-warning>-->
      <toast-alert ref="toastComp"></toast-alert>
      <router-view  class="container-fluid" ></router-view>
  </div>
</template>

<script>
    import { alertMixin } from './Banet/mixins/alertMixin.js';
    import { translationMixin } from './Banet/mixins/translationMixin.js';
    import BanetInfo from './Banet/errorsAndNotifications/BanetInfo.vue';
    import BanetWarning from './Banet/errorsAndNotifications/BanetWarning.vue';
    import ToastAlert from './Banet/errorsAndNotifications/ToastAlert.vue';

    export default {
        mixins: [alertMixin, translationMixin],
        data: function(){
            return {
                infoMessage: [],
                warningMessage: [],
                isHtml: true,
                staticLink: true
            }
        },
        computed: {
            appErrorsActive: function(){
                this.warningMessage = this.$store.getters.getErrorMessages;
                if(this.translations[this.warningMessage]){
                    this.warningMessage = this.translations[this.warningMessage];
                }
                return this.$store.getters.errorsActive;
            }
        },
        components: {
            banetInfo: BanetInfo,
            banetWarning: BanetWarning,
            toastAlert: ToastAlert
        },
        methods: {
            closeAlert: function(){
                this.infoMessage = [];
                this.alertInfo(0, 'close');
            },
            closeAlertWarning: function(){
                this.$store.dispatch('unsetErrors');
                this.warningMessage = [];
                this.appErrorsActive = false;
            }
        },
    }
</script>

<style>

    .divider {
        clear: both;
        border-bottom: solid 1px #9eac8e;
        margin: 20px 0 5px;
    }

    .slide-enter-active {
        animation: slide-in 200ms ease-out forwards;
    }

    .slide-leave-active {
        animation: slide-out 200ms ease-out forwards;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-active {
        opacity: 0
    }

    @keyframes slide-in {
        from {
            transform: translateY(-30px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    @keyframes slide-out {
        from {
            transform: translateY(0);
            opacity: 1;
        }
        to {
            transform: translateY(-30px);
            opacity: 0;
        }
    }

    .modal {
        display: block;
    }

    .modal-dialog {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        max-height: 90%;
        overflow: auto;
        margin: 0;
    }
    .modal-body {
        overflow: auto;
    }

</style>



// WEBPACK FOOTER //
// App.vue?63fe3840